export default __webpack_public_path__ + "static/car_ins_homepage-70f17f7ca19234f303a58aa1a2e51fe5.webp";